import CopyButton from "@/components/copy-button";
import { Button } from "@/components/ui/button";
import {
  usePublishInboxPlacementReport,
  useUnPublishInboxPlacementReport,
} from "@/hooks/use-inboxplacement";
import { PlacementType } from "@/types/inboxPlacements.types";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const InboxPlacementPublishButton = ({
  ids,
  email,
  isPublic,
  type,
  companyId,
  reportType,
}: {
  ids: string[];
  email: string;
  companyId: string;
  isPublic: boolean;
  type: "history-table" | "details-page";
  reportType: PlacementType;
}) => {
  const { mutateAsync: publishReport, isPending: isPublishing } =
    usePublishInboxPlacementReport();

  const { mutateAsync: unPublishReport, isPending: isUnPublishing } =
    useUnPublishInboxPlacementReport();

  const queryClient = useQueryClient();

  const handlePublish = async () => {
    try {
      if (isPublic) {
        await unPublishReport({
          ids,
        });
      } else {
        await publishReport({
          ids,
        });
      }

      const eventName = isPublic
        ? "inbox_placement_unpublished"
        : "inbox_placement_published";
      window.cioanalytics?.track(eventName, {
        email: email,
        type: reportType,
      });

      if (type === "history-table") {
        queryClient.invalidateQueries({
          queryKey: ["inboxplacements-test-history"],
        });
      } else {
        queryClient.invalidateQueries({
          queryKey: ["inboxplacements", email],
        });
      }

      toast.success(
        `Report ${isPublic ? "unpublished" : "published"} successfully`
      );
    } catch (error) {
      toast.error(`Failed to ${isPublic ? "unpublish" : "publish"} report`);
    }
  };

  return (
    <div className="h-full flex items-center justify-center gap-2">
      <Button
        variant="outline"
        size="sm"
        className="w-full"
        onClick={handlePublish}
        disabled={isPublishing || isUnPublishing}
        isLoading={isPublishing || isUnPublishing}
      >
        {isPublic ? "Unpublish" : "Publish"}
      </Button>

      {isPublic && (
        <CopyButton
          text={`https://inboxdoctor.ai/shared-inboxplacement-report/${companyId}/${ids[0]}?type=${reportType}`}
        />
      )}
    </div>
  );
};

export default InboxPlacementPublishButton;
